import React from 'react'
import { useTranslation } from 'react-i18next'
import { CRIcon, CRRender, Inline } from '../../../crRender'
import { generator } from '@/utils/NumbersUtils'

const UploadedItem = ({
    fileItem,
    preview,
    fileErrors,
    handleRemoveFile,
    getFileIcon,
    formatFileSize
}) => {
    
    const { t } = useTranslation()

    const clickRemoveFile = () => 
        handleRemoveFile(fileItem?.id)
    
    return (
        <div className="file-item">
            <div className="file-preview">
                <CRRender isRender={!!preview?.preview}>
                    <img
                        src={preview?.preview}
                        alt={fileItem?.value?.name}
                        className="file-preview-image"
                    />
                </CRRender>
                <CRRender isRender={!preview?.preview}>
                    <CRIcon
                        icon={getFileIcon(fileItem?.value?.type)}
                        className="file-preview-icon"
                    />
                </CRRender>
            </div>
            <div className="file-info">
                <p className="file-name">{fileItem?.value?.name}</p>
                <p className="file-size">{formatFileSize(fileItem?.value?.size)}</p>
                <CRRender isRender={fileErrors.length > 0}>
                    <div className="file-errors">
                        {fileErrors?.mapWithKey((error, idx) => (
                            <Inline key={error.key} className="error-text">
                                {error}
                            </Inline>
                        ))}
                    </div>
                </CRRender>
            </div>
            <button
                type="button"
                className="file-remove-btn"
                onClick={clickRemoveFile}
                title={t('remove')}
            >
                <CRIcon icon="mdi:close" />
            </button>
        </div>
    )
}

export default UploadedItem

